import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ReportTabItem from './ReportTabItem';
import ExpandCollapseIcon from './assets/ExpandCollapse.svg';
import Collapsible from 'react-collapsible';

const StyledList = styled.ul`
  padding: 0;
  width: 100%;
  list-style-type: none;
`;

const StyledListItem = styled.li`
  width: 100%;
`;

const ReportPageMenuItemImg = styled.img`
  ${props => (props.expanded ? '' : 'transform : rotate(-90deg);')};
  opacity: 1;
  vertical-align: middle;
  margin-right: 9px;
`;

const StyledListItemName = styled.span`
  vertical-align: top;
`;

const StyledListItemButton = styled.button`
  width: 100%;
  border: none;
  box-sizing: border-box;
  padding: 10px 50px 10px 80px;
  margin: 0;
  text-decoration: none;
  background-color: ${props => (props.expanded ? '#00013e' : '#00013e')};
  color: rgba(255, 255, 255, 0.8);
  font-family: inherit;
  font-size: 16px;
  border-radius: 0;
  cursor: pointer;
  text-align: initial;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.2);
    color: #white;
  }
`;

class ReportPageItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpened:
        props.parentActive && props.selectedReportPageId === props.reportPage.id
    };
    this.toggleState = this.toggleState.bind(this);
  }

  toggleState() {
    this.setState({
      isOpened: !this.state.isOpened
    });
  }

  getStyledListItembutton() {
    const { reportPage, tabIndex, ...props } = this.props;
    return (
      <StyledListItemButton onClick={this.toggleState} tabIndex={tabIndex}>
        <ReportPageMenuItemImg
          alt=""
          src={ExpandCollapseIcon}
          expanded={this.state.isOpened}
        />
        <StyledListItemName>{reportPage.name}</StyledListItemName>
      </StyledListItemButton>
    );
  }

  render() {
    const { reportPage, tabIndex, ...props } = this.props;

    return reportPage.tabs.length > 1 ? (
      <StyledListItem>
        <Collapsible
          trigger={this.getStyledListItembutton()}
          open={this.state.isOpened}
        >
          <StyledList>
            {reportPage.tabs.map(tab => (
              <ReportTabItem
                tabIndex={this.state.isOpened && tabIndex === 0 ? 0 : -1}
                key={tab.id}
                parentActive={reportPage.id === props.selectedReportPageId}
                currentReportPageId={reportPage.id}
                reportTab={tab}
                customReportTabName={
                  reportPage.tabs.length === 1 && reportPage.name
                }
                {...props}
              />
            ))}
          </StyledList>
        </Collapsible>
      </StyledListItem>
    ) : (
      <StyledListItem>
        <StyledList>
          {reportPage.tabs.map(tab => (
            <ReportTabItem
              tabIndex={tabIndex}
              key={tab.id}
              parentActive={reportPage.id === props.selectedReportPageId}
              currentReportPageId={reportPage.id}
              reportTab={tab}
              customReportTabName={
                reportPage.tabs.length === 1 && reportPage.name
              }
              {...props}
            />
          ))}
        </StyledList>
      </StyledListItem>
    );
  }
}

export default ReportPageItem;
